import styled from '@emotion/styled';
import { FileReference } from '@kaizenplatform/belfast-entity';
import { DynamicSchemaFieldKey, FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { Divider as _Divider } from '@material-ui/core';
import { ClassAttributes, createElement, ReactElement } from 'react';

import { ProjectDetailsForShowFragment } from '../../../../generated/graphql';
import { subText } from '../../../constant/color';
import { SPACING_UNIT } from '../../../constant/spacing';
import mq from '../../../styleUtility/mediaquery';
import _Field from './Field';
import _Section from './Section';

interface Props {
  definition: ProjectDetailsForShowFragment['creativeBriefDefinition'];
  value: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  files: Map<DynamicSchemaFieldKey, FileReference[]>;
  className?: string;
}

const CreativeBriefDetail = ({ definition, value, files, className }: ClassAttributes<HTMLElement> & Props) => {
  const sections = definition.sections
    .reduce((whole, section) => {
      const fields = section.fields.map((field) => (
        <Field field={field} value={value.get(field.key) ?? null} files={files.get(field.key)} key={field.key} />
      ));

      return [
        ...whole,
        <Section section={section} key={section.id}>
          {fields}
        </Section>,
        <Divider key={`div-${section.id}`} />,
      ];
    }, [] as ReactElement<any>[])
    .slice(0, -1);

  return <div className={className}>{sections}</div>;
};

const Section = styled(_Section)({
  marginBottom: SPACING_UNIT * 3,
  ':last-child': {
    marginBottom: SPACING_UNIT,
  },
});

const Divider = styled(_Divider)({
  marginBottom: SPACING_UNIT * 3,
  ':last-child': {
    marginBottom: SPACING_UNIT,
  },
});

const Field = styled(_Field)({
  [mq('sp')]: {
    display: 'block',
    '& > *:first-of-type': {
      textAlign: 'left',
      fontSize: 12,
      fontWeight: 400,
      marginBottom: 4,
      color: subText,
    },
    '& h3': {
      wordBreak: 'break-word',
      whiteSpace: 'initial',
      fontSize: 14,
      lineHeight: 1.4,
    },
  },
});

export default CreativeBriefDetail;
